"use client";

import styled from "styled-components";

//Components
import { Tabs, TabsList, TabsTrigger } from "../../ui/tabs";

export const TabContainer = styled(Tabs)`
  width: 100%;
`;

export const ListTabs = styled(TabsList)`
  width: 100%;
  gap: 10px;
`;

export const TabButton = styled(TabsTrigger)`
  border: none;

  &[data-state="active"] {
    background: var(--primarySystem100);
    color: var(--white);
    border: none;
  }
`;
